import { ReactNode } from 'react';
import { Button, Dialog, lucideIcons } from '@round/creatorbase-ui';
import styles from './SubScreen.module.css';

const { ArrowLeftIcon } = lucideIcons;

type Props = {
    backLabel: string;
    onBack: () => void;
    title: string;
    children: ReactNode;
};

const SubScreen = ({ backLabel, onBack, title, children }: Props) => (
    <div className={styles.screen}>
        <Dialog.Header>
            <Button variant="bare" size="sm" onClick={onBack} className={styles.backButton}>
                <ArrowLeftIcon size="14" />
                {backLabel}
            </Button>
            <Dialog.Title>{title}</Dialog.Title>
        </Dialog.Header>

        <div className={styles.body}>{children}</div>
    </div>
);

export default SubScreen;
